export const appointmentSlotsGridStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 143px)",
  gap: 7,
  marginTop: 8
};
